{
  "resources": "VIEWERS",
  "dimensions": ["REGION"],
  "filters": [
    {
      "key": "{{:resourceType:}}",
      "value": "{{:id:}}",
      "op": "=="
    }
  ],
  "dateRange": {
    "start": "{{:startDateTime:}}",
    "end": "{{:endDateTime:}}"
  }
}